import Net from '../../util/net';
import {
  GetChannelMsgTopicInfoByMsgSeqReq,
  GetChannelMsgTopicInfoByMsgSeqRsp,
  GetChannelTopicListReq,
  GetChannelTopicListRsp,
  GetGroupTopicListReq,
  GetGroupTopicListRsp,
  GetGroupTopicListSimpleReq,
  GetGroupTopicListSimpleRsp,
  GetTopicExtendInfoReq,
  GetTopicExtendInfoRsp,
  GetTopicInfoReq,
  GetTopicInfoRsp,
  GetTopicMsgsReq,
  GetTopicMsgsRsp,
  GetTopicMsgsSortType,
} from '../../typings/proto';
import { TRequest } from '../../util/net/typings';
import humps from 'humps';

export default {
  getChannelTopicList(data: TRequest<GetChannelTopicListReq>): Promise<GetChannelTopicListRsp> {
    return Net.requestFullList<GetChannelTopicListRsp, GetChannelTopicListReq>({
      path: 'knockknock.TopicSrv/GetChannelTopicList',
      data,
    });
  },
  /**
   * 话题参与评论信息
   * @param topicId 话题id
   * @param size 话题评论个数
   */
  getTopicMsgs(
    topicId: string,
    size: number,
    msgSeq?: string | undefined,
    sortType = GetTopicMsgsSortType.GetTopicMsgsSortTypeAsc,
  ): Promise<GetTopicMsgsRsp> {
    return Net.request<GetTopicMsgsRsp, GetTopicMsgsReq>({
      data: {
        topicId,
        msgSeq,
        size,
        sortType,
      },
      path: 'knockknock.TopicSrv/GetTopicMsgs',
    });
  },
  /**
   * 话题详细信息
   * @param topicIdList 话题id列表
   */
  getTopicInfo(topicIdList: Array<string>): Promise<GetTopicInfoRsp> {
    return Net.request<GetTopicInfoRsp, GetTopicInfoReq>({
      path: 'knockknock.TopicSrv/GetTopicInfo',
      data: {
        topicIdList,
      },
      camelizeResponse: false,
    }).then((res) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data = res as any;
      data.topicInfos = data.topic_infos;
      delete data.topic_infos;
      Object.keys(data.topicInfos).forEach((key) => {
        data.topicInfos[key] = humps.camelizeKeys(data.topicInfos[key]);
      });
      return data as GetTopicInfoRsp;
    });
  },
  /**
   * 群组详细信息
   * @param topicId 话题id
   * @param needGroupChannelBaseInfo 是否需要群组和频道基础信息
   */
  getTopicExtendInfo(topicId: string, needGroupChannelBaseInfo: boolean): Promise<GetTopicExtendInfoRsp> {
    return Net.request<GetTopicExtendInfoRsp, GetTopicExtendInfoReq>({
      data: {
        topicId,
        needGroupChannelBaseInfo,
      },
      path: 'knockknock.TopicSrv/GetTopicExtendInfo',
    });
  },
  getGroupTopicList(data: TRequest<GetGroupTopicListReq>): Promise<GetGroupTopicListRsp> {
    return Net.requestFullList<GetGroupTopicListRsp, GetGroupTopicListReq>({
      path: 'knockknock.TopicSrv/GetGroupTopicList',
      data,
    });
  },
  getGroupTopicListSimple(data: TRequest<GetGroupTopicListSimpleReq>): Promise<GetGroupTopicListSimpleRsp> {
    return Net.requestFullList<GetGroupTopicListSimpleRsp, GetGroupTopicListSimpleReq>({
      path: 'knockknock.TopicSrv/GetGroupTopicListSimple',
      data,
    });
  },
  getChannelMsgTopicInfoByMsgSeq(data: TRequest<GetChannelMsgTopicInfoByMsgSeqReq>):
  Promise<GetChannelMsgTopicInfoByMsgSeqRsp> {
    return Net.requestFullList<GetChannelMsgTopicInfoByMsgSeqRsp, GetChannelMsgTopicInfoByMsgSeqReq>({
      path: 'knockknock.TopicSrv/GetChannelMsgTopicInfoByMsgSeq',
      data,
      camelizeResponse: false,
    }).then((res) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data = res as any;
      data.topicInfos = data.topic_infos;
      data.topicInfosV2 = data.topic_infos_v2;
      data.msgSeqTopicIds = humps.camelizeKeys(data.msg_seq_topic_ids);
      delete data.topic_infos;
      delete data.topic_infos_v2;
      delete data.msg_seq_topic_ids;
      Object.keys(data.topicInfos).forEach((key) => {
        data.topicInfos[key] = humps.camelizeKeys(data.topicInfos[key]);
      });
      Object.keys(data.topicInfosV2).forEach((key) => {
        data.topicInfosV2[key] = humps.camelizeKeys(data.topicInfosV2[key]);
      });
      return data as GetChannelMsgTopicInfoByMsgSeqRsp;
    });
  },
};
